import * as types from './mutations-types';

export const mutations = {
  [types.SHOW_PROJECT_MODAL](state, status) {
    state.modalProject = status;
  },

  [types.FETCH_PROJECTS_SUCCESS](state, { projects }) {
    projects.map((project) => {
      if (project.project) {
        project.value = project.project.id;
        project.text = project.project.name;
      }
    });

    state.projects = projects.sort((project1, project2) => {
      if (project1.updatedAt < project2.updatedAt) return 1;
      else if (project1.updatedAt > project2.updatedAt) return -1;
      return 0;
    });
  },

  [types.SET_PROJECT](state, project_id = null) {
    let project = state.projects[0];
    if (project_id) {
      project = state.projects.find((p) => p.projectID === project_id);
    }

    if (!project) {
      return;
    }

    localStorage.setItem('project', JSON.stringify(project.project));
    state.project = project && project.project;
  },

  [types.STORE_PROJECT_SUCCESS](state, project) {
    localStorage.setItem('project', JSON.stringify(project));
    state.project = project;
    project.value = project.id;
    project.text = project.name;
    state.projects.push(project);
  },

  [types.UPDATE_PROJECT_SUCCESS](state, project) {
    localStorage.setItem('project', JSON.stringify(project));
    state.project = project;
    state.projects.map((proj) => {
      if (proj.project.id === project.id) {
        proj.text = project.name;
        proj.project.name = project.name;
        proj.project.description = project.description;
      }
    });
  },

  [types.SHOW_PROJECT_INVITE_MODAL](state, status) {
    state.modalInvite = status;
  },

  [types.INVITE_USERS_FAILURE](state, notExistsEmails) {
    state.notExistsEmails = notExistsEmails;
  },

  [types.DESTROY_PROJECT_SUCCESS](state) {
    localStorage.removeItem('project');
    state.project = null;
    state.projectDeleted = true;
  },

  [types.INVITE_USERS_FAILURE](state, notExistsEmails) {
    state.notExistsEmails = notExistsEmails;
  },
};
